import { Component, Input } from '@angular/core';
import { BaseModal } from '../base-modal';

@Component({
    selector: 'ui-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.less']
})
export class ConfirmModalComponent extends BaseModal {

    @Input() title = 'Confirmation';
    @Input() description = 'Changes you made may not be saved. Are you sure you want to leave?';
    @Input() showButtonNo = true;
    @Input() showButtonYes = true;
    @Input() showCloseIcon = true;
    @Input() buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'OK'
    };
}
